import type { Map as MLMap } from "maplibre-gl";

/**
 * Run fn once the map's style can take new sources/layers.
 * isStyleLoaded() is also false while a source is still loading tiles, after the one-off "load" event has fired —
 * so wait for whichever of "load" / "idle" comes first instead of "load" only.
 *
 * V3.10.1 — `key`: only the NEWEST waiting call with the same key runs. Without it, an older call made while the map was
 * still loading (e.g. zones drawn with an empty list right after opening the map) could run after a newer one and
 * overwrite it — the cause of zones sometimes missing after coming back to the map until the browser tab was switched.
 */
export function onStyleReady(map: MLMap, fn: () => void, key?: string) {
  const m = map as any;
  const waits: Record<string, number> = (m.__styleWaits ??= {});
  const token = key ? (waits[key] = (waits[key] ?? 0) + 1) : 0;
  const current = () => !key || waits[key] === token;
  if (map.isStyleLoaded() || m.style?._loaded) { if (current()) fn(); return; }
  let done = false;
  const run = () => { if (done) return; done = true; map.off("load", run); map.off("idle", run); if (current()) fn(); };
  map.on("load", run);
  map.on("idle", run);
}
